import React, { Component } from "react";

export default class NexPlayer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  divMounted(el) {
    if (el == null) {
      return;
    }

    window.nexplayer.Setup({
      key: "5b05467494e55c07d4141cd2",
      div: el,
      src: this.props.manifestURL,
      callbacksForPlayer: (player, videoElement) => {
        videoElement.addEventListener("timeupdate", () => {
          this.props.timeUpdateCallback(videoElement.currentTime * 1000);
        });
      }
    });
  }

  render() {
    return <div style={{ width: "100%" }} ref={this.divMounted.bind(this)} />;
  }
}



// WEBPACK FOOTER //
// ./src/VOD/Players/NexPlayer.js